function HPO() {
  return (
    <div>
      <li className="bullet-item">
        The top level concepts from the{' '}
        <a className="tt" target="_blank" rel="noreferrer" href="https://hpo.jax.org/app/">
          Human Phenotype Ontology
        </a>
      </li>
    </div>
  );
}

export default HPO;
